// video play button init
export default function initVideoPlayButton() {
	function playVideo() {
		const $holder = jQuery(this).closest('.video-wrap');
		const $iframe = $holder.find('iframe');
		let src = $iframe.data('src') || $iframe.attr('src');

		src = src.indexOf('?') != -1 ? `${src}&autoplay=1` : `${src}?autoplay=1`;

		$iframe.attr({
			src: src,
			'data-src': src
		});

		$holder.addClass('iframe-ready');

		return false;
	}

	jQuery(document).on('click', '.video-wrap:has(iframe) .btn-play', playVideo);
}
